import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import { blockStatement } from "@babel/types";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";

var headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};


class LeaseBrokerDetails extends React.Component {
  state = {
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    initialValues: {

    },
    additionalDetails: {
      'gla': 0,
      'carpet': 0,
      'usable': 0
    },
    isDisabled: true,
    brokerGroup: [],
    brokerList: [],
    brokerageAmt: 0,

  };
  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }
  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/broker-group/fetch-broker-list`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brokerGroup: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    
    let athis= this;
    axios.get(`${apiUrl.apiUrl.url}/create-lease/fetch-lease-broker-form?id=${this.props.match.params.id}`).then((response) => {
      let data = response.data;
      athis.state.initialValues.brokerGroup = data.brokerGroup;
      athis.state.initialValues.brokerId = data.brokerId;

      athis.state.initialValues.brokerage_logic = data.brokerage_logic;
      athis.state.initialValues.rate = data.rate;
      athis.state.initialValues.uom = data.uom;
      athis.state.initialValues.percentage = data.percentage;
      athis.state.initialValues.on_area = data.on_area;

      if (data.brokerageAmt != '') {
        athis.state.initialValues.brokerageAmt = data.brokerageAmt;
      }
      if (data.brokerageMonths != '') {
        athis.state.initialValues.brokerageMonths = data.brokerageMonths;
      }

      athis.state.additionalDetails = data.additionalDetails;

      athis.setState({ brokerList: data.companies });
    });


    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-broker-form?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {

    //     this.state.initialValues.brokerGroup = data.brokerGroup;
    //     this.state.initialValues.brokerId = data.brokerId;

    //     this.state.initialValues.brokerage_logic = data.brokerage_logic;
    //     this.state.initialValues.rate = data.rate;
    //     this.state.initialValues.uom = data.uom;
    //     this.state.initialValues.percentage = data.percentage;
    //     this.state.initialValues.on_area = data.on_area;

    //     if (data.brokerageAmt != '') {
    //       this.state.initialValues.brokerageAmt = data.brokerageAmt;
    //     }
    //     if (data.brokerageMonths != '') {
    //       this.state.initialValues.brokerageMonths = data.brokerageMonths;
    //     }

    //     this.state.additionalDetails = data.additionalDetails;

    //     console.log(data.additionalDetails, " data.additionalDetails;")

    //     this.setState({ brokerList: data.companies });

    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }

  handleGroupChange = (e) => {
    console.log(e.target.value, "groyp changes");
    let groupid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/broker-group/get-group-brokers/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brokerList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
    //brokerList
  }

  calculateFullAmt = (e, value, setFieldValue) => {
    //brokerage_logic
    let rate = this.state.initialValues.rate;
    let brokerageMonths = this.state.initialValues.brokerageMonths;
    let percentage = this.state.initialValues.percentage;
    let on_area = this.state.initialValues.on_area;

    let totalAmt = 0;
    if (value.brokerage_logic != "Flat Amount") {
      let area = 0;
      if (on_area == "Usable Area") {
        area = this.state.additionalDetails.usable;
      } else if (on_area == "Carpet Area") {
        area = this.state.additionalDetails.carpet;
      } else if (on_area == "Gross Leasable Area") {
        area = this.state.additionalDetails.gla;
      }
      if (value.brokerage_logic == "Rate Basis") {
        totalAmt = parseFloat(area) * parseInt(brokerageMonths) * parseFloat(rate);
      } else {
        totalAmt = (parseFloat(area) * parseInt(brokerageMonths) * parseFloat(rate)) * parseFloat(percentage) / 100;
      }
      this.state.initialValues.brokerageAmt = totalAmt;
      setFieldValue("brokerageAmt", totalAmt);
      this.setState({});
    }
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  render() {
    if (this.state.redirect == true) {
      //let url = this.props.match;
      let url = this.props.match.path;
      let urlPath = url.split("/");

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={
            `/${urlPath[1]}/utilities/` + this.props.match.params.id
            //"/createlease/utilities/" + this.props.match.params.id
          }
        />
      );
    }
    return (
      <div
        className="parentContainer createLease"

      >
        <div>
          <div>
            <div className="absoluteItemForTopBar">
              <div className="new_breadcrumbs_design">
                <ul className="d-flex align-items-center gap-3 p-0 m-0">
                  <li>Create Lease</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>Parties, Unit & Brand Details</li>
                  <li><FontAwesomeIcon icon={faChevronRight} /></li>
                  <li>
                    <a href="#">Broker Details</a>
                  </li>
                </ul>
              </div>
            </div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                if (!this.mainFormValidator.allValid()) {
                  this.mainFormValidator.showMessages();
                  return false;
                }
                var self = this;
                axios({
                  method: "post",
                  url: `${apiUrl.apiUrl.url}/create-lease/update-broker-details?lease_id=${this.props.match.params.id}`,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,

                setFieldValue
              }) => (
                <>
                  <div className="unitFormContainerNew">
                    <Form autoComplete="off" >
                      <div className="newGridSectionParent">
                        <div className="newGridSectionForFormMain">

                          <div className="newGridSectionInner">
                            <label>
                              Broker Group <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as={"select"}
                                name={"brokerGroup"}
                                onChange={(e) => {
                                  handleChange(e);
                                  this.handleGroupChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {
                                  this.state.brokerGroup.map((obj) => (
                                    <option
                                      key={obj.id}
                                      value={`${obj.id}`}
                                      label={`${obj.name}`}
                                    />
                                  ))
                                }
                              </Field>
                              {this.mainFormValidator.message(
                                "lease Broker",
                                values.brokerGroup,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Select Broker <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as={"select"}
                                name={"brokerId"}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {
                                  this.state.brokerList.map((obj) => (
                                    <option
                                      key={obj.id}
                                      value={`${obj.id}`}
                                      label={`${obj.company_name}`}
                                    />
                                  ))
                                }
                              </Field>
                              {this.mainFormValidator.message(
                                "broker Id",
                                values.brokerId,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          <div className="newGridSectionInner">
                            <label>
                              Select Logic <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                as={"select"}
                                name={"brokerage_logic"}
                                onChange={(e) => {
                                  setFieldValue("brokerageAmt", 0);
                                  handleChange(e);
                                }}
                              >
                                <option value="" label="Select" defaultValue />
                                {
                                  ["Flat Amount", "Rate Basis", "Percentage of rent Basis"].map((obj) => (
                                    <option
                                      key={obj}
                                      value={`${obj}`}
                                      label={`${obj}`}
                                    />
                                  ))
                                }
                              </Field>
                              {this.mainFormValidator.message(
                                "Logic",
                                values.brokerage_logic,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>
                          </div>

                          {["Rate Basis", "Percentage of rent Basis"].includes(values.brokerage_logic) && (
                            <>
                              <div className="newGridSectionInner">
                                <label>
                                  Rate
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="rate"
                                    onChange={(e) => {
                                      handleChange(e);
                                      this.state.initialValues.rate = e.target.value;
                                      this.setState({});
                                      this.calculateFullAmt(e, values, setFieldValue);
                                    }}
                                  />
                                  {this.mainFormValidator.message(
                                    "Rate",
                                    values.rate,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  Brokerage Months
                                </label>
                                <div className="position-relative">
                                  <Field
                                    type="text"
                                    name="brokerageMonths"
                                    onChange={(e) => {
                                      handleChange(e);
                                      this.state.initialValues.brokerageMonths = e.target.value;
                                      this.setState({});
                                      this.calculateFullAmt(e, values, setFieldValue);
                                    }}
                                  />
                                  {this.mainFormValidator.message(
                                    "Months",
                                    values.brokerageMonths,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>

                              <div className="newGridSectionInner">
                                <label>
                                  On Area
                                </label>
                                <div className="position-relative">
                                  <Field
                                    as="select"
                                    name="on_area"
                                    onChange={(e) => {
                                      handleChange(e);
                                      this.state.initialValues.on_area = e.target.value;
                                      this.setState({});
                                      this.calculateFullAmt(e, values, setFieldValue);
                                    }}
                                  >
                                    <option value="" label="Select" defaultValue />
                                    <option value="Usable Area" label="Usable Area" />
                                    <option value="Carpet Area" label="Carpet Area" />
                                    <option value="Gross Leasable Area" label="Gross Leasable Area" />
                                  </Field>
                                  {this.mainFormValidator.message(
                                    "Area",
                                    values.on_area,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </>
                          )}

                          {["Percentage of rent Basis"].includes(values.brokerage_logic) && (
                            <div className="newGridSectionInner">
                              <label>
                                Percentage
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name="percentage"
                                  onChange={(e) => {
                                    handleChange(e);
                                    this.state.initialValues.percentage = e.target.value;
                                    this.setState({});
                                    this.calculateFullAmt(e, values, setFieldValue);
                                  }}
                                />
                                {this.mainFormValidator.message(
                                  "Percentage",
                                  values.percentage,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                          )}

                          <div className="newGridSectionInner">
                            <label>
                              Brokerage Amount
                            </label>
                            <div className="position-relative">
                              <Field
                                type="text"
                                name="brokerageAmt"
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                              />
                              <ErrorMessage
                                name="brokerageAmt"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>

                        </div>
                        <div className="button_group d-flex align-items-center gap-3 justify-content-end mt-5">
                        <button
                          className="add_button"
                          type="submit"
                        >
                          Save Draft
                        </button>
                        <button
                          className="reset_button"
                          type="button"
                        >
                          <Link to="/createlease">
                            Cancel
                          </Link>
                        </button>
                      </div>
                      </div>
                    </Form>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
      </div>
    );
  }
}

export default withRouter(LeaseBrokerDetails);
